import React from "react";
import { withRouter } from "react-router-dom";
import { Backdrop } from "@networkraildigitalfactory/components";
import { SignOut } from "phosphor-react";
import { ReactComponent as SitemapIcon } from "../../assets/sitemapIcon.svg";
import HeaderMenuItems from "../Header/HeaderMenuItems";
import DFLogo from "../../assets/DFLogoLarge.png";
import "./SideDrawer.css";

const SideDrawer = (props) => {
  const { isDirtyForm, renderDirtyNavModal } = props;

  const openSitemapModal = () => {
    props.close();
    document.getElementById("toolbarSitemap").click();
  };

  const openLogoutModal = () => {
    props.close();
    document.getElementById("toolbarLogout").click();
  };

  let drawerClasses = "side-drawer";

  if (props.show) {
    drawerClasses = "side-drawer open";
  }

  return (
    <>
      {props.show && <Backdrop close={props.close} />}
      <nav className={drawerClasses}>
        <HeaderMenuItems
          click={props.close}
          showIcons
          user={props.user}
          isLineManager={props.isLineManager}
          setObjectivesFilters={props.setObjectivesFilters}
          isDirtyForm={isDirtyForm}
          renderDirtyNavModal={renderDirtyNavModal}
        >
          <li
            tabIndex={props.show ? 0 : -1}
            role="menuitem"
            onClick={openSitemapModal}
            onKeyDown={(e) => (e.key === "Enter" ? openSitemapModal() : undefined)}
          >
            <div className="icon-wrapper">
              <SitemapIcon color="rgba(55,81,157, 1)" size={32} />
            </div>
            Sitemap
          </li>
        </HeaderMenuItems>
        <li
          tabIndex={props.show ? 0 : -1}
          role="menuitem"
          onClick={openLogoutModal}
          onKeyDown={(e) => (e.key === "Enter" ? openLogoutModal() : undefined)}
          id="drawerLogout"
        >
          Logout
          <div className="icon-wrapper">
            <SignOut color="rgba(55,81,157, 1)" size={32} />
          </div>
        </li>
        <img src={DFLogo} alt="DF logo" />
      </nav>
    </>
  );
};

export default withRouter(SideDrawer);
